import React, { useState } from "react"
import { Box, Link } from "@chakra-ui/react"
import { Outlet } from "react-router-dom"
import TOSModal from "./TOSModal"

export default function StandardFooter() {
  const [open, setOpen] = useState(false)

  const onOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <TOSModal isOpen={open} onClose={handleClose} />
      <Box pb={{ base: 8, md: 0 }}>
        <Outlet />
      </Box>
      <Box
        position={{ base: "fixed", md: "absolute" }}
        bottom="0"
        right="0"
        left={{ base: "0", md: "auto" }}
        height={{ base: 8, md: 16 }}
        color="black"
        fontSize="sm"
        zIndex={999}
        display="flex"
        justifyContent={{ base: "center", md: "flex-end" }}
        alignItems={{ base: "center", md: "flex-start" }}
        pr={{ base: 0, md: 28 }}
        pb={{ base: "0", md: "4" }}
      >
        <Box
          bg="white"
          boxShadow="floating"
          borderRadius={{ base: "0", md: "md" }}
          p={{ base: "1", md: "3" }}
          width={{ base: "100%", md: "auto" }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <p>
            &copy; 2025,{" "}
            <Link href="https://blindinsight.com" isExternal>
              Blind Insight, Inc.
            </Link>{" "}
            |{" "}
            <Link href="https://docs.blindinsight.io" isExternal>
              View docs
            </Link>{" "}
            |{" "}
            <Link href="https://www.blindinsight.com/privacy-policy" isExternal>
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link as="button" onClick={onOpen}>
              Terms of Service
            </Link>
          </p>
        </Box>
      </Box>
    </>
  )
}
